/* eslint-disable */
(function() {
  var $ = require('jquery');

  //Change hrefs to GA phone number
  setInterval(function() {
    var $telNo = $('.telNo');

    if ($telNo.length > 0) {
      $telNo.attr('href', 'tel:' + $telNo.html().replace(/ /g, ''));
    }
  }, 2000);
})();
